export type RankItem = {
  rank: number;
  title: string;
  desc: string;
  metric: string;
  tag: string;
};

export type RankingBoard = {
  id: string;
  title: string;
  subtitle: string;
  period: string;
  items: RankItem[];
};

export const rankingBoards: RankingBoard[] = [
  {
    id: 'week-hot',
    title: '本周热搜榜',
    subtitle: '按一周内被讨论的总时长排序，只看还在持续的话题。',
    period: '2026 第 36 周',
    items: [
      { rank: 1, title: '秋季文旅新线路陆续公布', desc: '多地结合节气推出短途线路，讨论集中在交通与住宿。', metric: '讨论 128 万', tag: '生活' },
      { rank: 2, title: '短剧行业进入品质竞争', desc: '观众开始关注剧本与制作，不再只看更新速度。', metric: '讨论 96 万', tag: '行业' },
      { rank: 3, title: '老牌综艺宣布回归新一季', desc: '阵容调整成为话题核心，讨论多为回忆向。', metric: '讨论 84 万', tag: '娱乐' },
      { rank: 4, title: '开学季校园创意短片走红', desc: '几所高校的迎新短片被大量转发，风格偏轻快。', metric: '讨论 71 万', tag: '影像' },
      { rank: 5, title: '国产动画电影话题度回升', desc: '关于美术风格的讨论带动了新一轮关注。', metric: '讨论 63 万', tag: '影视' },
      { rank: 6, title: '城市夜间市集重新热闹起来', desc: '夜市内容成为短视频热门题材，带动周边关注。', metric: '讨论 55 万', tag: '生活' },
    ],
  },
  {
    id: 'month-meme',
    title: '本月热梗榜',
    subtitle: '按进入日常语言的速度排序，衡量一个梗的渗透力。',
    period: '2026 年 8 月',
    items: [
      { rank: 1, title: '「先这样吧」式收尾句式', desc: '用于结束一场无解的讨论，语气轻松不冒犯。', metric: '渗透 92%', tag: '语言' },
      { rank: 2, title: '「收到但不一定办」的礼貌回应', desc: '在职场对话中被高频使用，带有轻微自嘲。', metric: '渗透 78%', tag: '职场' },
      { rank: 3, title: '「量子速读」式夸张形容', desc: '用来吐槽把简单事情说得复杂。', metric: '渗透 66%', tag: '吐槽' },
      { rank: 4, title: '「已读慢回」的社交自辩', desc: '为消息回复慢找台阶的说法，接受度较高。', metric: '渗透 54%', tag: '社交' },
      { rank: 5, title: '「气氛组」的新用法', desc: '从娱乐场景延伸到日常聚会自嘲。', metric: '渗透 43%', tag: '社交' },
    ],
  },
  {
    id: 'quarter-collection',
    title: '季度精选合集榜',
    subtitle: '按专题的完整度与更新频率排序，选值得反复回看的合集。',
    period: '2026 Q3',
    items: [
      { rank: 1, title: '年度热搜大盘点', desc: '条目最全、更新最勤，覆盖整年话题脉络。', metric: '完读 87%', tag: '热搜盘点' },
      { rank: 2, title: '网络热梗图鉴', desc: '结构清晰，每个梗都标注了当前状态。', metric: '完读 81%', tag: '网络话题' },
      { rank: 3, title: '出圈短视频精选', desc: '按地点重排，附带当地生活注脚。', metric: '完读 76%', tag: '影像现场' },
      { rank: 4, title: '内容创作者进化史', desc: '四十年形态变化的完整梳理。', metric: '完读 69%', tag: '娱乐观察' },
      { rank: 5, title: '国潮联名盘点', desc: '按融合深度分级，标准明确。', metric: '完读 62%', tag: '文化盘点' },
    ],
  },
];